import axios from 'axios';

const API_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/api";


export const authService = {
  login: async (email, senha) => {
    const response = await axios.post(`${API_URL}/auth/login`, { email, senha });
    return response.data;
  },

  cadastro: async (userData) => {
    const response = await axios.post(`${API_URL}/auth/cadastro`, userData);
    return response.data;
  },

  recuperarSenha: async (email) => {
    const response = await axios.post(`${API_URL}/auth/recuperar-senha`, { email });
    return response.data;
  },

  resetarSenha: async (token, nova_senha, confirmar_senha) => {
    const response = await axios.post(`${API_URL}/auth/resetar-senha`, {
      token,
      nova_senha,
      confirmar_senha,
    });
    return response.data;
  },

  refresh: async (refresh_token) => {
    const response = await axios.post(`${API_URL}/auth/refresh`, { refresh_token });
    return response.data;
  },

  getCurrentUser: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) return null;

    try {
      // Decodifica o token para obter informações do usuário
      const payload = JSON.parse(atob(token.split('.')[1]));
      
      // Busca dados do usuário pelo endpoint /me
      const response = await axios.get(`${API_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        ...response.data,
        role: response.data?.role || payload.role,
      };
    } catch (error) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      return null;
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
  },

  getAuthHeader: () => {
    const token = localStorage.getItem('access_token');
    if (!token) return {};
    return {
      Authorization: `Bearer ${token}`,
    };
  },
};
